import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

//we import  the auth object from the firebase file, this is to set the logged in user to the logged in user, etc
import { auth } from "./firebase";

import "firebase/compat/auth";
import firebase from "firebase/compat/app";

const FirebaseContext = React.createContext();

// function to use Context below. custom hook?
export function useForAuthorisation() {
  return useContext(FirebaseContext);
}
//main function
export function FirebaseAuth({ children }) {
  const [loggedInUser, setLoggedInUser] = useState();
  const [loading, setLoading] = useState(true);
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  var provider = new firebase.auth.GoogleAuthProvider();

  const isAppCheckError = (error) => {
    const code = String(error?.code || "").toLowerCase();
    const message = String(error?.message || "").toLowerCase();

    return (
      code.startsWith("app-check/") ||
      message.includes("app check") ||
      message.includes("appcheck") ||
      message.includes("recaptcha")
    );
  };

  const createAppCheckAuthError = (error) => {
    const wrappedError = new Error(
      "App Check verification failed. Please refresh the page and try again.",
    );

    wrappedError.code = String(error?.code || "app-check/failed");
    wrappedError.name = error?.name || "FirebaseAppCheckError";
    wrappedError.originalMessage = error?.message || "";
    wrappedError.isAppCheckError = true;

    return wrappedError;
  };
  // firebase has its own function to get and set the current user, we call this function in the signup component.
  // we first pass it as props to the Provider below.

  let location = useLocation();
  function signupUser(email, password) {
    return auth.createUserWithEmailAndPassword(email, password).then(() => {
      return auth.currentUser.sendEmailVerification();
    });
  }
  function signInWithGoogle(verify) {
    return auth
      .signInWithPopup(provider)
      .then((result) => {
        if (verify === "verify") {
          return auth.currentUser.sendEmailVerification();
        } else return result;
      })
      .catch((error) => {
        if (handleAppCheckError(error)) {
          throw createAppCheckAuthError(error);
        }
        throw error;
      });
  }

  // let { from } = location.state || { from: { pathname: "Login" } };
  async function login(email, password) {
    //local was previously session but new tabs required re login
    await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    try {
      await auth.signInWithEmailAndPassword(email, password);
    } catch (error) {
      if (handleAppCheckError(error)) {
        throw createAppCheckAuthError(error);
      }
      throw error;
    }
  }

  function logout() {
    return auth.signOut();
  }

  function emailVerify() {
    return auth.currentUser.sendEmailVerification();
  }
  function ResetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }
  function updateLoggedInUsersPassword(newpass) {
    return loggedInUser.updatePassword(newpass);
  }
  function updateLoggedInUsersEmail(emailUpdate) {
    return loggedInUser.updateEmail(emailUpdate);
  }
  function deleteUserProfile(user) {
    return auth.currentUser.delete();
  }
  function ReauthenticateWithCredential(email, pass) {
    return auth.currentUser.reauthenticateWithCredential(email, pass);
  }
  let userDetails = auth && auth.currentUser;
  let name, emailDetails, emailVerified;
  //photoUrl, uid, emailVerified;

  if (userDetails != null) {
    name = userDetails.displayName;
    emailDetails = userDetails.email;

    //  photoUrl = userDetails.photoURL;
    emailVerified = userDetails.emailVerified;
    // console.log(emailDetails, emailVerified);
    //  uid = userDetails.uid; // The user's ID, unique to the Firebase project. Do NOT use
    // this value to authenticate with your backend server, if
    // you have one. Use User.getToken() instead.
  }

  const handleAppCheckError = (error) => {
    if (isAppCheckError(error)) {
      setShowRefreshModal(true);
      return true;
    }
    return false;
  };

  const refreshPage = () => {
    window.location.reload();
  };
  //useEffect so it only runs once, we also unsubscribe the current user
  useEffect(() => {
    const unsubscribe =
      auth &&
      auth.onAuthStateChanged((user) => {
        setLoggedInUser(user);
        // console.log("123456");
        setLoading(false);
      });

    //unsubscribe();
    // the above firebase method returns a method which unsubscribes users when we return/unmount the component
    return unsubscribe;
  }, []);

  // Set global reference for error handling
  useEffect(() => {
    window.firebaseAuthContext = { setShowRefreshModal };
  }, []);

  // //added recently
  //   const [isLoggedIn, setLoggedIn] = useState(false);

  //   function readSession() {
  //     const user = window.sessionStorage.getItem(
  //       `firebase:authUser:${auth.apiKey}:[DEFAULT]`
  //     );
  //     if (user) setLoggedInUser(true);
  //   }
  //   useEffect(() => {
  //     readSession();
  //   }, []);

  // value is an object that we pass as props to FirebaseContext.provider which provides theses object value props to all
  // its nested components, etc. the objects props are passed throuhout our components.
  const value = {
    loggedInUser,
    signupUser,
    signInWithGoogle,
    login,
    logout,
    emailVerify,
    emailVerified,
    loading,
    ResetPassword,
    updateLoggedInUsersPassword,
    updateLoggedInUsersEmail,
    deleteUserProfile,
    ReauthenticateWithCredential,
    emailDetails,
    name,
    location,
    showRefreshModal,
    setShowRefreshModal,
    handleAppCheckError,
    refreshPage,
  };
  return (
    <FirebaseContext.Provider value={value}>
      {children}
      {showRefreshModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "2rem",
              borderRadius: "20px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              maxWidth: "400px",
              width: "90%",
            }}
          >
            <h3 style={{ color: "#dc2626", marginBottom: "1rem" }}>
              ⚠️ Refresh Required
            </h3>
            <p style={{ color: "#374151", marginBottom: "1.5rem" }}>
              App Check verification failed due to inactivity. Please refresh
              the page to continue.
            </p>
            <button
              onClick={refreshPage}
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
                color: "white",
                padding: "12px 30px",
                borderRadius: "25px",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow =
                  "0 4px 20px rgba(102, 126, 234, 0.3)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              🔄 Refresh Page
            </button>
          </div>
        </div>
      )}
    </FirebaseContext.Provider>
  );
}
